import {Component, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-four-square-layout",
    imports: [],
    templateUrl: "./four-square-layout.component.html",
    styleUrl: "./four-square-layout.component.scss",
})
export class FourSquareLayoutComponent {}
